<template lang="pug">
.main-wrapper
    .nav-wrapper
        Navigation
    VGrid.container.project-content.fade-in(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax1")
                    img.main-image(
                        src="@/assets/images/bean/Bean - Mockup - 2.png",
                        data-depth="0.3"
                    )
                    img.dot-pattern(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square(data-depth="0.15")
                    .filled-squares(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title Bean
                        .title-section-description
                            .company By Influx.Studio
                            .description Students all around the world struggle with staying focused <br/> on their studies because of procrastination and lack of sleep.<br/> They receive no reward for studying and are not guaranteed <br/> to receive a pass on the test they studied so hard for. <br/> That’s what the goal of Bean is; to keep students motivated <br/> by rewarding them for a healthy study lifestyle.
                    .title-section-content
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Mobile Design, UI/UX, Branding
                        .project-menu
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#light") 02 Light Theme
                            .menu-item
                                a.label(data-link="#dark") 03 Dark Theme
                            .menu-item
                                a.label(data-link="#solutions") 04 Solutions
                            .menu-item
                                a.label(data-link="#technologies") 05 Technologies
            .title-section-gridlines

    .light
        VGrid#overview.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Overview
            VRow.overview-section-spacing
                VCol(variant="xs-10")
                    VRow.space-around
                        VCol(variant="xs-6")
                            .general-item 
                                span.title The Mission
                                p.description The goal of this application is to motivate users to stay of their phones when they need to be focused on whatever they are doing or when they need to sleep. The app lets the user choose a desired time they want to focus or sleep and the users will then be awarded points based on the amount of time they selected, if they don’t used their phone while the countdown timer is running. If they use their phone during that time, they will lose the points. The points can be converted to vouchers from coffee shops and other popular stores.
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title Services
                                p.description Bean offers an easy-to-use motivation service for student who lack the passion to stay focused on their studies and keep their mental health in check.
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title The Outcome
                                p.description We create a native mobile application, specifically catered to students with easy to use functionality so our users can spend less time on their phones and more time on their studies.
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title The Impact
                                p.description The launch of this application provided excellent results for immediate users, with most saying that they easily get enough sleep each day and are well rested to stay focused on their studies.
                VCol(variant="xs-2") 
                    span.general-section-share Share This
                    .general-section-social-share
                        VRow
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="#",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/facebook.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="#",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/twitter.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="#",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/insta.svg") 
                    .general-section-project-scope
                        span.scope Scope of Project
                        .scope-item Mobile Design
                        .scope-item UI/UX
                        .scope-item Brand Design

    .light-grey
        VGrid.container.mockups-trigger(variant="container")
            VRow.side-scroll.mockups
                VCol.carousel-container(variant="xs-12")
                    img.carousel.carousel-scroll(
                        src="@/assets/images/bean/Light Focus01.png",
                        data-depth="0.3"
                    )
                    img.carousel.carousel-scroll(
                        src="@/assets/images/bean/Light Login.png",
                        data-depth="0.3"
                    )
                    img.carousel.carousel-scroll(
                        src="@/assets/images/bean/Light Main Menu.png",
                        data-depth="0.3"
                    )
                    img.carousel.carousel-scroll(
                        src="@/assets/images/bean/Premium Sleep01.png",
                        data-depth="0.3"
                    )
                    img.carousel.carousel-scroll(
                        src="@/assets/images/bean/Premium Statistics.png",
                        data-depth="0.3"
                    )
                    img.carousel.carousel-scroll(
                        src="@/assets/images/bean/Premium FocusStart.png",
                        data-depth="0.3"
                    )

    .light
        VGrid#light.container(variant="container")
            VRow
                VCol.image-scroll-section(variant="xs-7")
                    .image-section 
                        img.left-image(
                            src="@/assets/images/bean/Light Main Menu.png",
                            data-depth="0.3"
                        )
                        p.figure-text-left Menu Home - Focus or Sleep
                    .image-section 
                        img.right-image(
                            src="@/assets/images/bean/Light Focus01.png",
                            data-depth="0.3"
                        )
                        p.figure-text-right Choose how long you want to focus
                    .image-section 
                        img.left-image(
                            src="@/assets/images/bean/Light FocusStart.png",
                            data-depth="0.3"
                        ) 
                        p.figure-text-left Focus for 30 minutes
                    .image-section 
                        img.right-image(
                            src="@/assets/images/bean/Light Sleep01.png",
                            data-depth="0.3"
                        )
                        p.figure-text-right Choose how long you want to sleep
                    .image-section 
                        img.left-image(
                            src="@/assets/images/bean/Light SleepStart.png",
                            data-depth="0.3"
                        )
                        p.figure-text-left Sleep for 30 minutes
                    .image-section 
                        img.right-image(
                            src="@/assets/images/bean/Light Statistics.png",
                            data-depth="0.3"
                        )
                        p.figure-text-right View statistics of your sessions

                VCol.section-title(variant="xs-5") Light Theme Design
                    VRow.overview-section-spacing
                        VCol(variant="xs-12")
                            .general-item.light-theme-trigger(
                                v-animate-onscroll="'animated fadeIn'"
                            )
                                span.title Menu Home
                                p.description The minimalistically designed menu screen features the 2 main buttons (Focus and Sleep) with an easy-to-see and easy-to-reach design concept in mind.
                                span.title Focus Select
                                p.description With easy-to-use sliders and large font size, this page is designed to let the user spend as little time on it as possible. The goal is to select the amount of time you would like to focus on your work and then to receive points based on that time.
                                span.title Focus Timer
                                p.description This page contains no buttons and no interactive elements. This is done to prevent the user from using their phone while the timer is running, as is the goal of the app itself.
                            .general-item.light-theme-trigger-2(
                                v-animate-onscroll="'animated fadeIn'"
                            )
                                span.title Sleep Select
                                p.description With the same design as the focus selection screen, this screen is also designed with the goal to get the user to select the amount of time they would like to sleep.
                                span.title Sleep Timer
                                p.description No interactivity means the user will stay away from their phone while they should be sleeping. Any interactivity with their phone will make them lose their reward.
                                span.title Statistics
                                p.description The statistics screen feature a lot of information about your interactivity with the app and how well you have been staying focused or asleep.
    .dark
        VGrid#dark.container(variant="container")
            VRow
                VCol.section-title.light-text(variant="xs-6") Dark Theme Design
                    VRow.overview-section-spacing
                        VCol(variant="xs-12")
                            .general-item.dark-theme-trigger(
                                v-animate-onscroll="'animated fadeIn'"
                            )
                                span.title.light-text Welcome
                                p.description.light-text The Welcome screen offers a quick single-action button to get started in the app.
                                span.title.light-text Sleep Select
                                p.description.light-text The dark theme offers a way for the user to use the app with less eye-strain in <br/>darker environments, like when they are about to sleep.
                                span.title.light-text Settings
                                p.description.light-text The settings screen allows the user to set some customisable options, such as<br/> the default focus or sleep times so they can spend even lesstime on the <br/> selection screens.
                            .general-item.dark-theme-trigger-2(
                                v-animate-onscroll="'animated fadeIn'"
                            )
                                span.title.light-text Focus Select
                                p.description.light-text The dark theme provides an aesthetic design on each of the pages and allows <br/>important elements such as the sliders to stand out more.
                                span.title.light-text Statistics
                                p.description.light-text The statistics screen allow the user to see a deep overview of their progress<br/> and activity on the app.
                                span.title.light-text Goal Failed
                                p.description.light-text This screen tells the player that they interacted with their phone and therefore <br/>lost their points.
                VCol.image-scroll-section(variant="xs-6")
                    .image-section 
                        img.left-image(
                            src="@/assets/images/bean/Premium Login.png",
                            data-depth="0.3"
                        )
                        p.figure-text-left.light-text Welcome page
                    .image-section 
                        img.right-image(
                            src="@/assets/images/bean/Premium Sleep02.png",
                            data-depth="0.3"
                        ) 
                        p.figure-text-right.light-text Sleep scheduling
                    .image-section 
                        img.left-image(
                            src="@/assets/images/bean/Premium Settings.png",
                            data-depth="0.3"
                        )
                        p.figure-text-left.light-text Edit your settings
                    .image-section 
                        img.right-image(
                            src="@/assets/images/bean/Premium Focus02.png",
                            data-depth="0.3"
                        ) 
                        p.figure-text-right.light-text Choose focus period
                    .image-section 
                        img.left-image(
                            src="@/assets/images/bean/Premium Statistics.png",
                            data-depth="0.3"
                        )
                        p.figure-text-left.light-text Statistics
                    .image-section 
                        img.right-image(
                            src="@/assets/images/bean/Premium TimerFail.png",
                            data-depth="0.3"
                        ) 
                        p.figure-text-right.light-text Failed to achieve goal

    .light
        VGrid#solutions.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technical Solutions
            VRow
                VCol(variant="xs-6") 
                    .general-item
                        span.title Problems
                        ol 
                            li.list-item 1. Cost-effect functionality that can prove to be useful to all students.
                            li.list-item 2. Valuable rewards to keep students motivated
                            li.list-item 3. Cost of business partnerships to provide valuable rewards
                VCol(variant="xs-6") 
                    .general-item
                        span.title Solutions
                        ol 
                            li.list-item 1. Successful fundraisers and crowdfunding websites helped to get the initial starting funds.
                            li.list-item 2. Relatable vouchers and gifts that can be redeemed from the in-app point system.
                            li.list-item 3. Created deals with businesses popular with a student-aged audience such as coffee shops.

    .light
        VGrid#technologies.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technologies Used
            VRow.align-center
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/flutter.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/dart.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/node.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/amazon.png",
                        data-depth="0.3"
                    )

    .cream
        VGrid.container(variant="container")
            VRow.contact-us
                VCol.contact-trigger(variant="xs-12")
                    h1.align-center.contact-description Want to work with us?
                    .align-center.scroll-down
                        router-link.contact-button.primary-button(
                            :to="{ name: 'home', query: { c: true } }",
                            data-cursor-shrink
                        ) Start A Project
                VCol(variant="xs-12")
                    .icon-scroll 
                    p.scroll-text Next Project: Swift

    //- div.cream
    //-     VGrid(variant="container").container
    //-         VRow
    //-             VCol(variant="xs-12")
    //-                 div.section
    //-                     div.outer
    //-                         div.inner Continue to next project

    .nav-wrapper.not-visible
        Navigation
    VGrid.container.project-content(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax2")
                    img.main-image.large(
                        src="@/assets/images/swift-mockups/banner.png",
                        data-depth="0.3"
                    )
                    img.dot-pattern(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title Swift <br/> POS <br/> System
                        .title-section-description
                            .company By Influx.Studio
                            .description We designed the Swift visual identity from the ground up, <br/> capturing the new companies excitement and value in a new <br/> logo and brand style guidelines. We then built a highly-effective <br/> system that helps create a contactless dining experience.
                    .title-section-content.project-align
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Software, Retail & Branding
                        .project-menu.transition
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#brand") 02 Brand
                            .menu-item
                                a.label(data-link="#customer") 03 Customer App
                            .menu-item
                                a.label(data-link="#management") 04 Management App
                            .menu-item
                                a.label(data-link="#solutions") 05 Solutions
                            .menu-item.scroll-trigger
                                a.label(data-link="#technologies") 06 Technologies

            .title-section-gridlines

    .static-elements
        .static-wrapper-inner.navigation-container
            //- Navigation.staticnav
        .static-wrapper-inner.static-footer
            p.copyright-info Copyright &copy; 2020 | Design by #[a(href="/contact") Influx Studios]
</template>

<script>
import Navigation from "@/components/navigation.vue";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import Parallax from "parallax-js";
import { EventBus } from "@/events/global-bus.js";

// import { TimelineMax, Back } from 'gsap'
import ScrollMagic from "scrollmagic";
// import { TweenLite } from 'gsap'
import $ from "jquery";

import Vue from "vue";
import FlexboxgridVue from "@vivid-web/flexboxgrid-vue";
import VueAnimateOnScroll from "vue-animate-onscroll";

Vue.use(VueAnimateOnScroll);

Vue.use(FlexboxgridVue);

export default {
    name: "Single-Work",
    computed: {
        workname() {
            return this.$route.params.workname;
        },
    },
    components: {
        Navigation,
    },
    methods: {},
    metaInfo() {
        return {
            title: this.workname,
        };
    },
    beforeDestroy() {
        $(window).off("scroll");
    },
    mounted() {
        function scrollToElement(selector) {
            $("html, body")
                .stop(true, false)
                .animate(
                    {
                        scrollTop: $(selector).offset().top,
                    },
                    500,
                    "swing"
                );
        }

        $(document).on("click", ".menu-item a", function (e) {
            e.preventDefault();
            scrollToElement($(this).attr("data-link"));
            return false;
        });
        window.scrollTo(0, 0);

        let self = this;

        $(window).scroll(function () {
            if (
                $(window).scrollTop() + $(window).height() ==
                    $(document).height() &&
                self.$route.name == "bean"
            )
                self.$router.push({ name: "swift" });
        });

        new Parallax(this.$refs.parallax1, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        new Parallax(this.$refs.parallax2, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        // TweenLite.defaultEase = Linear.easeNone;
        var controller = new ScrollMagic.Controller();

        var revealElements = document.getElementsByClassName("carousel-scroll");
        for (var i = 0; i < revealElements.length; i++) {
            // create a scene for each element
            new ScrollMagic.Scene({
                triggerElement: revealElements[i], // y value not modified, so we can use element as trigger as well
                offset: 100, // start a little later
                triggerHook: 0.9,
                duration: "90%",
            })
                .setClassToggle(revealElements[i], "visible") // add class toggle
                .addTo(controller);
        }

        new ScrollMagic.Scene({
            triggerElement: "#light",
            offset: 400,
            duration: 470,
        })
            .setPin(".image-scroll-section")
            .setPin(".light-theme-trigger")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: ".light-theme-trigger-2",
            offset: 200,
            duration: 800,
        })
            .setPin(".image-scroll-section")
            .setPin(".light-theme-trigger-2")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#dark",
            offset: 400,
            duration: 570,
        })
            .setPin(".image-scroll-section")
            .setPin(".dark-theme-trigger")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: ".dark-theme-trigger-2",
            offset: 200,
            duration: 820,
        })
            .setPin(".image-scroll-section")
            .setPin(".dark-theme-trigger-2")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: ".scroll-down",
            offset: 0,
        })
            .on("start", function () {
                if (this.$route.name != "home" || this.$route.name != "works")
                    $("html, body").animate(
                        { scrollTop: $(document).height() },
                        2000
                    );
            })
            .addTo(controller);

        EventBus.$emit("rescan-cursor");
    },
};
</script>

<style lang="scss" scoped>
html {
    scroll-snap-type: y mandatory;
}

.main-wrapper {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    height: 100%;
    background-color: $cl-cream;
    box-sizing: border-box;
    //
}

.nav-wrapper {
    margin-top: $body-padding-desktop-y;
    padding: 0 $body-padding-desktop-x;

    &.not-visible {
        visibility: hidden;
    }
}

// Title Layout Section
.title-section {
    position: relative;
    background-color: $cl-cream;
}

.title-section-gridlines {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        to right,
        transparentize(#575757, 0.9),
        transparentize(#575757, 0.9) 1px,
        $cl-cream 1px,
        $cl-cream 10%
    );
    z-index: 0;
}

.title-section-wrapper {
    width: 100%;
    height: 100%;
    background-color: $cl-cream;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    position: relative;
    z-index: 2;

    .title-section-inner-wrapper {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;

        .title-section-title {
            color: $cl-grey;
            font-size: 7rem;
            line-height: 1.2em;
        }

        .title-section-image {
            margin-right: 8rem;
            position: relative;

            .main-image {
                max-width: 30rem;
                position: relative;
                z-index: 3;

                &.large {
                    max-width: 35rem;
                }
            }

            .dot-pattern {
                position: absolute;
                width: 70%;
                margin-left: 12rem;
                margin-top: 15rem;
                z-index: 1;
            }

            .outline-square {
                position: absolute;
                width: 75%;
                height: 100%;
                border: 1px solid $cl-grey;
                margin-top: -5rem;
                margin-left: 10rem;
                z-index: 1;
            }

            .filled-squares {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    width: 9.6rem;
                    height: 9.6rem;
                    bottom: -2.4rem;
                    right: -2.6rem;
                    background-color: $cl-red;
                }

                &::after {
                    content: "";
                    position: absolute;
                    width: 16rem;
                    height: 16rem;
                    top: -3.6%;
                    left: -3.6rem;
                    border: 1px solid $cl-grey;
                }
            }
        }

        .title-section-content-container {
            margin-top: 4.8rem;

            .project-information {
                display: flex;
                flex-direction: row;
            }

            .title-section-content {
                margin-left: 20rem;
                margin-top: 15rem;
                font-weight: 500;
                font-size: 1.8rem;

                &.project-align {
                    margin-left: -5rem;
                }

                .project-focus {
                    font-weight: 600;
                    font-size: 1.6rem;
                }

                .project-focus-items {
                    font-weight: 500;
                    font-size: 1.6rem;
                }

                .project-menu {
                    margin-top: 4.8rem;
                    margin-bottom: 7rem;
                    display: flex;
                    flex-direction: row;
                    &.transition {
                        visibility: hidden;
                        // margin-bottom: 0;
                    }
                    .menu-item {
                        font-size: 1.6rem;
                        font-family: "Muli", Helvetica, sans-serif;
                        font-weight: 600;
                        position: relative;
                        padding-right: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        a.label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }

                            &.active {
                                position: relative;
                                &::after {
                                    bottom: 0;
                                    height: 2px;
                                    background-color: $cl-red;
                                    left: 0;
                                    width: 5rem;
                                    content: "";
                                    position: absolute;
                                }
                            }
                        }
                    }
                }
            }

            .title-section-description {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                margin-left: 14rem;
                white-space: nowrap;

                .company {
                    color: $cl-red;
                    font-weight: 600;
                    font-size: 1.4rem;
                }

                .description {
                    color: $cl-grey;
                    font-weight: 500;
                    font-size: 1.4rem;
                    margin-bottom: 1.8rem;
                }
            }
        }
    }
}

.light {
    background-color: white;
    position: relative;
    width: 100%;
}

.light-grey {
    background-color: #f6f6f6;
    position: relative;
    width: 100%;
}

.section {
    width: 100%;
    //   height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    text-transform: uppercase;
    font-weight: 700;
}

.inner {
    position: relative;
}

.outer {
    border-bottom: solid white 2px;
    overflow: hidden;
}

.cream {
    background-color: $cl-cream;
    position: relative;
    width: 100%;
}

.dark {
    background-color: $cl-grey;
    position: relative;
    width: 100%;
}

.container {
    @media (min-width: 1200px) and (max-width: 1599px) {
        max-width: 80%;
    }

    @media (min-width: 1600px) {
        max-width: 75%;
    }

    &.project-content {
        height: 90vh;

        &.fade-in {
            animation: fadeIn ease 2s;
        }

        @keyframes fadeIn {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    }

    &.project-change {
        height: 100vh;
    }

    position: relative;

    .section-title {
        color: $cl-grey;
        font-size: 3rem;
        font-weight: 400;
        font-family: "Poppins", Helvetica, sans-serif;
        margin-top: 6rem;

        &.line {
            position: relative;
            &::after {
                bottom: 0;
                height: 3px;
                background-color: $cl-red;
                left: 0;
                width: 5rem;
                content: "";
                position: absolute;
            }
        }

        &.light-text {
            color: white;
        }

        &.light-theme-trigger {
        }
    }

    .align-center {
        display: flex;
        justify-content: center;
        margin-bottom: 5rem;
        margin-top: 1.5rem;

        .percentage {
            font-size: 4rem;
            color: $cl-red;
        }

        .results-description {
            font-size: 1.5rem;
            font-weight: 500;
        }
    }

    .icon-scroll,
    .icon-scroll:before {
        position: absolute;
        left: 50%;
    }

    .scroll-text {
        font-size: 1.6rem;
        font-weight: 500;
        position: absolute;
        left: 52%;
        margin-top: 1rem;
        opacity: 0.7;
        margin-left: 1rem;
    }

    .icon-scroll {
        width: 40px;
        height: 70px;
        margin-left: -20px;
        top: 100%;
        margin-top: -35px;
        box-shadow: inset 0 0 0 1px $cl-grey;
        border-radius: 25px;
    }

    .icon-scroll:before {
        content: "";
        width: 8px;
        height: 8px;
        background: $cl-grey;
        margin-left: -4px;
        top: 8px;
        border-radius: 4px;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        animation-name: scroll;
    }

    @keyframes scroll {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translateY(46px);
        }
    }

    .contact-us {
        display: flex;
        justify-content: center;
        margin-bottom: 2rem;
        margin-top: 1.5rem;

        .contact-description {
            font-size: 4rem;
            font-weight: 600;
            margin-top: 4rem;
            margin-bottom: 4rem;
        }

        .contact-button {
            background-color: $cl-cream;
            margin-top: 0;

            &:hover {
                background-color: $cl-red;
            }
        }

        &.align-center {
            display: flex;
            justify-content: center;
        }
    }

    .overview-section-spacing {
        margin-top: 1.5rem;
        margin-bottom: 4rem;
    }

    .image-carousel {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10rem;

        .carousel-item {
            width: 100rem;
        }
    }

    .side-scroll {
        margin-top: 6rem;
        margin-bottom: 6rem;

        .carousel {
            max-width: 28rem;
            max-height: 50rem;
            position: relative;
            z-index: 3;
            margin-right: 5px;

            &.carousel-scroll {
                opacity: 0;
                transform: translateX(-40px);
                transition: all 0.6s ease-out;

                &.visible {
                    opacity: 1;
                    transform: none;
                }
            }
        }
    }

    .slogan-section {
        display: flex;
        justify-content: center;
        text-align: center;

        .brand-slogan {
            font-weight: 600;
            font-size: 6rem;

            .slogan-outline {
                border: 3px solid $cl-red;
                padding-right: 2rem;
                padding-left: 2rem;
                transition: background-color 1s;

                /* &:hover {
                    color: white;
                    background-color: $cl-grey;
                } */
            }
        }
    }

    .image-scroll-section {
        display: flex;
        flex-direction: column;
        margin-top: 8rem;
        margin-bottom: 5rem;

        .image-section {
            position: relative;
            margin-bottom: -20rem;

            .left-image {
                position: relative;
                height: 50rem;
            }

            .right-image {
                position: relative;
                left: 30rem;
                height: 50rem;
            }

            .figure-text-left {
                font-size: 1.3rem;
                font-weight: 800;
                margin-left: 1rem;

                &.light-text {
                    color: white;
                }
            }

            .figure-text-right {
                font-size: 1.3rem;
                font-weight: 800;
                text-align: center;
                margin-left: 1rem;

                &.light-text {
                    color: white;
                }
            }
        }

        .laptop-image-section {
            position: relative;
            margin-bottom: 2rem;

            .image {
                position: relative;
            }
        }
    }

    .section-description {
        color: $cl-grey;
        font-weight: 500;
        font-size: 1.5rem;
        margin-top: 0rem;
        margin-bottom: 2rem;
    }

    .general-item {
        .title {
            color: $cl-grey;
            font-weight: 600;
            font-size: 2rem;
            font-family: "Poppins", Helvetica, sans-serif;

            &.light-text {
                color: white;
            }
        }

        .description {
            color: $cl-grey;
            font-weight: 500;
            font-size: 1.5rem;
            margin-top: 1rem;
            margin-bottom: 2rem;

            &.light-text {
                color: white;
            }
        }

        ol {
            line-height: 1.8em;
            margin-top: 1.5rem;
        }

        ol > li.list-item {
            font-weight: 500;
            font-size: 1.5rem;
        }
    }

    .general-section-share {
        font-weight: 700;
        font-size: 1.3rem;
    }

    .general-section-social-share {
        display: flex;
        flex-direction: row;
        margin-top: 1rem;

        .contact-info-social {
            &:hover {
                img {
                    opacity: 1;
                }
            }
            img {
                width: 2.2rem;
                height: 2.2rem;
                opacity: 0.75;
                transition: opacity 200ms ease-in-out;
            }

            &:not(:last-child) {
                margin-right: 1rem;
            }
        }
    }

    .general-section-project-scope {
        margin-top: 5rem;
        .scope {
            font-weight: 700;
            font-size: 1.4rem;
        }
        .scope-item {
            font-weight: 500;
            font-size: 1.3rem;
        }
    }

    .website-link {
        font-weight: 700;
        font-size: 1.4rem;
        color: $cl-red;
        margin-top: 5rem;

        &:hover {
            text-decoration: underline;
            text-decoration-color: $cl-grey;
        }
    }

    .technology-img {
        filter: grayscale(100%);
        width: 20rem;
        height: 7rem;
        object-fit: contain;

        &:hover {
            filter: grayscale(0%);
        }
    }
}

.static-elements {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    pointer-events: none;

    .copyright-info {
        color: $cl-cream-darker;
    }

    @include respond-below(lg) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
        position: absolute;

        .copyright-info {
            display: none;
        }
    }
}
</style>